module.exports = __webpack_public_path__ + "img/resized-20160625-130623.4ffd02b3.jpg";